export default __webpack_public_path__ + "static/media/cover_color_4.d31b9c9c.png";